/** First paint of the mobile date sheet. One month keeps the tap under the INP budget. */
export const MOBILE_DATE_PICKER_INITIAL_MONTHS = 1;

/** Full scrollable range, applied on the frame after the sheet has painted. */
export const MOBILE_DATE_PICKER_FULL_MONTHS = 13;

/**
 * @param {boolean} expanded
 * @returns {number}
 */
export function mobileDatePickerMonthCount(expanded) {
  return expanded ? MOBILE_DATE_PICKER_FULL_MONTHS : MOBILE_DATE_PICKER_INITIAL_MONTHS;
}
